module.exports = __webpack_public_path__ + "static/media/cr.1301db57.svg";